import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import {
  useSortable,
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { useSelector } from 'react-redux';
import ContentRenderer from './ContentRender';
import DropPlaceholder from './DropPlaceholder';

const SortableItem = ({ step, idx, spacerHeight }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id: step.id,
      data: {
        step,
        idx,
      },
    });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div className="ContentListDroppable-item" ref={setNodeRef} style={style}>
      <ContentRenderer
        type={step.contentType}
        step={step}
        idx={idx}
        spacerHeight={spacerHeight}
        listeners={listeners}
        attributes={attributes}
      />
    </div>
  );
};

const ContentList = ({ spacerHeight }) => {
  const { steps } = useSelector(state => state);

  const { listeners, setNodeRef, transform, transition } = useDroppable({
    id: 'ContentListDroppable',
    data: {
      parent: null,
      isContainer: true,
    },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <SortableContext items={steps} strategy={verticalListSortingStrategy}>
      <div
        className="ContentListDroppable"
        ref={setNodeRef}
        style={style}
        {...listeners}
      >
        {steps.length > 0 ? (
          <>
            {steps.map((step, idx) => {
              return (
                <SortableItem
                  key={step.id}
                  step={step}
                  idx={idx}
                  spacerHeight={spacerHeight}
                />
              );
            })}
          </>
        ) : (
          <DropPlaceholder />
        )}
      </div>
    </SortableContext>
  );
};

export default ContentList;
